import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../features/authSlice";
import userReducer from "../features/userSlice";
import aepsReducer from "../features/aepsSlice";
import sidebarReducer from "./sidebarSlice";
const persistConfig = {
  key: "merchant_root",
  storage,
  whitelist: ["sidebar"],
};


const rootReducer = combineReducers({
  auth: authReducer,
      aeps: aepsReducer,
  user: userReducer,
  sidebar: sidebarReducer,
});


const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);
